<template>
    <div class="utm-loading-box" :style="{'height': initHight}">
      <div class="animation-shadow"></div>
      <div class="entity-quadrilateral"></div>
      <svg  width="64" height="58" class="entity-triangle">
        <polygon class="triangle" stroke-linejoin="round" points="31,6 6,49 56,49"/>
      </svg>
      <slot>
        <div class="utm-loading-text">Loading ...</div>
      </slot>
    </div>
</template>

<script>
    /*参数描述
    * height：动画盒子的高度，盒子的高度决定了动画跳动的高度，传参时可传100px,也可传100,默认是200px
    * */
    export default {
      name: "utmLoading",
      data(){
        return{

        }
      },
      props:{
        height:{
          type:String,
          default:'100%',
        },
      },
      computed:{
        initHight: function(){
          return !this.height ? '200px':this.height.indexOf('px') > -1 ? this.height:this.height + 'px';
        },
      },

    }
</script>

<style scoped>
  .utm-loading-box{
    width: 100%;
    position: relative;
    margin-top: 50px;
    text-align: center;
  }
  .utm-loading-box .utm-loading-text{
    position: absolute;
    color: #059FE8;
    font-size: 24px;
    font-weight: 700;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: -40px;
    width: 100%;
  }
  .utm-loading-box .triangle {
    fill: #059FE8;
    stroke: #059FE8;
    stroke-width: 6px;
  }
  /*四边形*/
  .entity-quadrilateral{
    position: absolute;
    bottom: 10px;
    left: 50%;
    margin-left: -25px;
    width: 50px;
    height: 50px;
    background: #A8D4FF;
    animation: substancEquadrilateral 2s infinite;
    z-index: 2;
    border-radius: 6px;
    opacity: 1;
  }
  /*三角形*/
  .entity-triangle{
    position: absolute;
    bottom: 5px;
    left: 50%;
    margin-left: -30px;
    animation: substanceTriangle 2s infinite;
    transform-origin: center;
    z-index: 3;
    opacity: 1;
  }
  /*动画阴影*/
  .animation-shadow{
    position: absolute;
    bottom: -5px;
    left: 50%;
    content: '';
    display: block;
    height: 20px;
    width: 25px;
    border-radius: 10px;
    z-index: 1;
    background: rgba(0, 0, 0, 0.2);
    transform: translatex(-50%) rotateX(60deg);
    animation: shadow 1s infinite;
    animation-direction: alternate;
    -webkit-filter: blur(4px);
    filter: blur(4px);
  }

  @keyframes substancEquadrilateral{
    0%{
      transform: scale(1) rotate(0);
      bottom: 10px;
      opacity: 1.0;
    }
    25%{
      transform: scale(.6) rotate(90deg);
      bottom: 100%;
      opacity: 1.0;
    }
    50%{
      transform: scale(1) rotate(180deg);
      bottom: 10px;
      opacity: 1.0;

    }
    51%,100%{
      opacity: 0.0;
    }
  }
  @keyframes substanceTriangle{
    0%,49%{
      opacity: 0.0;
    }
    50%{
      opacity: 1.0;
      transform: scale(1) rotate(0);
      bottom: 5px;
    }
    75%{
      opacity: 1.0;
      transform: scale(.6) rotate(120deg);
      bottom: 100%;
    }
    100%{
      opacity: 1.0;
      transform: scale(1) rotate(240deg);
      bottom: 5px;
    }
  }
  @keyframes shadow{
    0% {
      width: 60px;
      height: 20px;
      -webkit-filter: blur(4px);
      filter: blur(4px);
      background: rgba(0, 0, 0, 0.7);
      opacity: .5;

    }
    60% {
      width: 25px;
      height: 20px;
      -webkit-filter: blur(4px);
      filter: blur(4px);
    }
    100% {
      background: rgba(0, 0, 0, 0.2);
      -webkit-filter: blur(4px);
      filter: blur(4px);
    }
  }


</style>



// WEBPACK FOOTER //
// src/admin/components/commonComponents/utmLoading.vue